import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BaseComponent } from 'app/components/base.component';
import { routesAnimation } from 'app/routing/animations';
import { ApiInterceptor } from 'app/services/api/api.service';
import { ApiError } from 'app/types';
import { SideMenuComponent } from 'app/components/side-menu/side-menu.component';
import { JsonPipe } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    animations: [routesAnimation],
    imports: [RouterOutlet, SideMenuComponent, JsonPipe],
})
export class AppComponent extends BaseComponent {
    title = 'gem';
    errorMessage?: object;
    showNotAllowed = false;

    ngOnInit() {
        const iconLinkTag = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
        if (iconLinkTag) {
            iconLinkTag.href = `assets/images/favicon-${this.isProd ? 'colored' : 'gray'}.ico`;
        }

        ApiInterceptor.onError.subscribe(error => {
            this.errorMessage = {
                url: error.url,
                error: (error as ApiError).error?.errors ?? (error.error as unknown),
            };
            setTimeout(() => {
                this.errorMessage = undefined;
            }, 6_000);
        });

        this.sessionService.onNotAllowedCountry.subscribe(() => {
            this.showNotAllowed = true;
        });
    }

    prepareRoute(outlet: RouterOutlet) {
        return outlet.activatedRouteData.animation as unknown;
    }

    closeNotAllowedOverlay() {
        this.showNotAllowed = false;
        this.sessionService.switchCountry(this.gemUser.countries[0].countryCode);
    }
}
